import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = { style: {"width":"1200px","transform":"scale(0.32)","transform-origin":"center 0","white-space":"wrap"} }
const _hoisted_4 = { style: {"color":"#222","font-size":"21px"} }
const _hoisted_5 = { style: {"font-size":"22px","font-weight":"bold","margin":"12px 0"} }
const _hoisted_6 = { style: {"font-size":"22px","font-weight":"bold","margin":"12px 0"} }
const _hoisted_7 = { style: {"margin-bottom":"24px"} }

import PcModuleCrossAnalysis from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-cross-analysis';

import { BaseRadio } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import { analysis } from '../../../../mock/_analysis';
import { BaseCard } from 'xrk-components';

const CHILD_KEY = '6_1';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-6-1',
  setup(__props) {

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-cross-analysis-1',
    moduleType: 'pc-module-cross-analysis-1'
  },
  2: {
    value: 'pc-module-cross-analysis-2',
    moduleType: 'pc-module-cross-analysis-2'
  },
  3: {
    value: 'pc-module-cross-analysis-3',
    moduleType: 'pc-module-cross-analysis-3'
  },
  4: {
    value: 'pc-module-cross-analysis-4',
    moduleType: 'pc-module-cross-analysis-4'
  },
  5: {
    value: 'pc-module-cross-analysis-5',
    moduleType: 'pc-module-cross-analysis-5'
  },
  6: {
    value: 'pc-module-cross-analysis-6',
    moduleType: 'pc-module-cross-analysis-6'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleCrossAnalysis.filter(comp => comp.__name === name)[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 240,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPE_MAPPING, (item, index) => {
          return _createElementVNode("div", {
            style: {"height":"230px","width":"100%"},
            key: index
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"230px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  value: item.value,
                  "model-value": _unref(curItem).value,
                  onClick: ($event: any) => (_unref(onChange)(item.value)),
                  style: {"height":"200px !important"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, _toDisplayString(_unref(analysis)[0].analysisMethodDescription), 1),
                        _createElementVNode("div", _hoisted_5, " 1." + _toDisplayString(_unref(analysis)[0].title), 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(analysis)[0].desc), 1),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(analysis)[0].crossTitle), 1),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(analysis)[0].crossDesc), 1)
                      ]),
                      (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)), _mergeProps({ ref_for: true }, {
                  tableHeaderList: _unref(analysis)[0].table.header,
                  tableDataList: _unref(analysis)[0].table.value
                }), null, 16))
                    ])
                  ]),
                  _: 2
                }, 1032, ["value", "model-value", "onClick"])
              ]),
              _: 2
            }, 1024)
          ])
        }), 64))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})